import React from 'react';
import './policyContent.scss';
import { Sign } from '../../components/image-router';
import { useTranslation } from 'react-i18next';

const PolicyContent = () => {
    const { t } = useTranslation();
    return (
        <>
            <div className='containerOurs'>
                <div className='textOurs'>
                    <div className='textContent'>
                         <div className='titleContent'>

                        </div>
                        <div className='subPolicy'>

                        </div>
                        <p>{t('policy.intro')}</p>
                        <div>&nbsp;</div>
                        <div className='subPolicy'>
                            {t('policy.infoCollectedTitle')}
                        </div>
                        <p>{t('policy.infoCollectedText')}</p>
                        <div>&nbsp;</div>
                        <div className='subPolicy'>
                            {t('policy.infoUsageTitle')}
                        </div>
                        <p>
                            {t('policy.infoUsageText')}
                            <div>&nbsp;</div>
                            {t('policy.securityCommitment')}
                        </p>
                        <div>&nbsp;</div>
                        <div className='subPolicy'>
                            {t('policy.cookiesTitle')}
                        </div>
                        <p>
                            {t('policy.cookiesText1')}
                            <div>&nbsp;</div>
                            {t('policy.cookiesText2')}
                        </p>
                        <div>&nbsp;</div>
                        <div className='subPolicy'>
                            {t('policy.thirdPartyTitle')}
                        </div>
                        <p>{t('policy.thirdPartyText')}</p>
                        <div>&nbsp;</div>
                        <div className='subPolicy'>
                            {t('policy.personalInfoTitle')}
                        </div>
                        <p>
                        {t('policy.personalInfoText')}
                        <div>&nbsp;</div>
                        {t('policy.noSellData')}
                        <div>&nbsp;</div>
                        {t('policy.reserveRight')}
                        </p>
                    </div>
                    <div className='signImage'>

                    </div>
                </div>
                <div className='directionsOurs'>
                </div>
            </div>
        </>

    );
}

export default PolicyContent;
